var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { clamp } from 'lodash';
import { css } from '@emotion/core';
import { Animation, Colors } from '@zapier/design-system/dist/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';
const Styles = labelStyles(__filename, {
    root: () => css({
        position: 'relative',
        height: 5,
        borderRadius: 2.5,
        backgroundColor: Colors.grey200,
    }),
    progress: (color) => [
        css({
            height: 'inherit',
            borderRadius: 'inherit',
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            transition: `all ${Animation.transitionDuration} ease-in-out`,
            backgroundColor: Colors[color],
        }),
    ],
});
export const ProgressBar = (_a) => {
    var { color = 'blue500', max = 1, min = 0 } = _a, props = __rest(_a, ["color", "max", "min"]);
    const value = clamp(props.value, min, max);
    const range = max - min;
    const decimal = (value - min) / range;
    const width = `${decimal * 100}%`;
    return (isolateComponent("div", { css: Styles.root() },
        isolateComponent("div", { css: Styles.progress(color), "data-testid": "progress", style: {
                width,
            } })));
};
//# sourceMappingURL=ProgressBar.js.map
